module.exports = __webpack_public_path__ + "img/154c15e41d06426386a50f952e30b191.996dafe3.png";